<template>
	<div class="entry discount-item" :class="{'archived':!item.is_active}"
	     @click="discountDetailsOpen=true">
		<div class="cell name">
			<span class=" cell-title">{{ item.name }}</span>
		</div>
		<div class="cell status" v-if="!item.is_active">
			<inline-svg :src="require('@/assets/img/close-circle-outline.svg')" />
			Inactive
		</div>
		<div class="cell status" v-else>
			<inline-svg :src="require('@/assets/img/circle-checked.svg')" />
			Active
		</div>
		<div class="cell brief">
			<span class="name">{{brief}}</span>
			<span class="more">all products</span>
		</div>
		<div class="cell time">
			{{ date }}
		</div>
		<div class="cell uses">
			{{ (item.uses||'0') + ' used' }}
		</div>
		<div class="cell actions">
			<quick-actions-btn :items="[
		            		{label:item.is_active?'Deactivate':'Activate',
		            		icon:require(`@/assets/img/${item.is_active?'close-circle-outline':'circle-checked'}.svg`)},
		            		'',{label:'Delete discount',disabled:false,icon:require('@/assets/img/cross.svg')}]"
			                   @menuClick="menuClick" :loading="menuLoading" />
		</div>

		<portal to="popup">
			<popup-backdrop v-if="discountDetailsOpen" @close="discountDetailsOpen=false">
				<discount-details-popup :discount-id="item.id" @close="discountDetailsOpen=false" />
			</popup-backdrop>

			<popup-backdrop v-if="deleteDiscountOpen" @close="deleteDiscountOpen=false">
				<delete-discount :level="0" :discount="item"
				                 @close="deleteDiscountOpen=false" @done="deleteDiscountOpen=false" />
			</popup-backdrop>
		</portal>

	</div>
</template>

<script>
import QuickActionsBtn from "@/components/base/quick-actions-btn";
import {getSymbol} from "@/helpers/currencies";
import API from '@/api';
import PopupBackdrop from "@/components/base/popup-backdrop";
import CustomerDetailsNew from "@/views/customers/customer-details-new";
import CancelOrder from "@/views/orders/cancel-order";
import DeleteOrder from "@/views/orders/delete-order";
import FulfillOrder from "@/views/orders/fulfill-order";
import AddTrackingInfo from "@/views/orders/add-tracking-info";
import OrderDetailsNew from "@/views/orders/order-details-new";
import {mapGetters} from "vuex";
import numbers from '@/helpers/numbers'
import {getGatewayById} from "@/helpers/gateways";
import RefundOrder from "@/views/orders/refund-order";
import IntermediatePanel from "@/views/orders/intermediate-panel";
import DiscountDetailsPopup from "@/views/store/discount-details";
import DeleteDiscount from "@/views/store/delete-discount";
const moment = require('moment-timezone');

export default {
	name: "discount-item", components: {
		DeleteDiscount,
		DiscountDetailsPopup,
		IntermediatePanel, PopupBackdrop, QuickActionsBtn}, props: ['item'],
	mixins:[API],
	data(){
		return {
			discountDetailsOpen: false,
			menuLoading: false,
			deleteDiscountOpen: false,
		}
	},
	computed:{
		...mapGetters(['getDiscountsStore']),
		canRefund(){
			return this.gateway.canRefund && !this.order.is_refunded && this.order.reference;
		},
		gateway(){
			return getGatewayById(this.item.gateway_id);
		},
		user() {
			return this.$store.state.userInfo || {};
		},
		date() {
			let d = this.item.created_at;

			let dd = moment(d);
			if (dd.isSame(moment(), 'day'))
				return 'Today, '+dd.format("HH:mm")
			if (dd.isSame(moment(), 'year'))
				return dd.format("DD MMM, HH:mm")
			return dd.format("DD MMM YYYY, HH:mm")
		},
		brief() {
			if (this.item.type==='percentage') // percentage
				return `${this.item.value}% off`
			else
				return `${this.currency}${this.item.value} off`
		},
		currency() {
			let c = this.$store.state.userInfo.currency_code;
			if (!c) return '$';
			return getSymbol(c);
		}
	},
	methods:{
		round(n){
			return numbers.round_to_two(n)
		},
		menuClick(e){
			if (e.action==='Activate'||e.action==='Deactivate') {
				this.updateActive();
			} else if (e.action==='Delete discount') {
				this.deleteDiscountOpen = true;
			}
		},
		async updateActive(){
			try {
				this.menuLoading = true;
				this.item.is_active = !this.item.is_active;

				let discount = await this.api.discounts.update(this.item);
				if (discount.error) this.$error(discount.error);
				else {
					let i = this.getDiscountsStore.findIndex(x=>x.id===this.item.id);
					if (i>=0) {
						this.getDiscountsStore.splice(i, 1, discount)
					}
				}
			} catch (e) {
				this.$error(e)
			} finally {
				this.menuLoading = false;
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.discount-item {
	border-radius: 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	line-height: 1.5;
	padding: 0 20px;
	opacity: 0;
	animation: appear 1 0.3s forwards;
	background: transparent !important;

	&:hover {
		background: $light-silver !important;
	}
	&.canceled {
		.cell-title, .cell-value, .amount, .name {
			text-decoration: line-through;
		}
	}
	&.archived {
		.cell-title, .cell-value, .status, .name, .uses, .time {
			color: $dark-grey;
		}
	}
}
</style>
